import * as React from "react";
import { TextInput, BooleanInput, ReferenceInput, SelectInput } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { SourceCustomer } from "../../Customer";

const RemoveReasonCreateForm = () => {
  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
                <BooleanInput label="Is Required" source="isRequired" />
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <ReferenceInput
                    label="CUSTOMER"
                    source="customerId"
                    required
                    reference={SourceCustomer}
                    filters={{ isActive__eq: true }}
                    fullWidth
                  >
                    <SelectInput optionText="customerId" optionValue="customerName" />
                  </ReferenceInput>
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="removeReasonTypeCode" label="REMOVE REASON CODE" required fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="removeReasonTypeName" label="REMOVE REASON NAME" required fullWidth />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default RemoveReasonCreateForm;
